<template>
	<label
		class="inline-block text-sm font-medium text-label-secondary"
		:class="{ 'text-lava': error }"
	>
		<slot />
	</label>
</template>
<script setup lang="ts">
defineProps<{
	error?: boolean
}>()
</script>
